import React from 'react';
import Student from "../components/student";
import {Card, Col, Row} from "react-bootstrap";
import {Get} from "../components/request";
import screens from "../screens";
import {
    faBuilding,
    faEnvelope,
    faFax,
    faHome,
    faHotel,
    faHouseUser,
    faIdCard,
    faLaptopHouse,
    faMailBulk,
    faMobileAlt,
    faPhoneAlt,
    faEuroSign
} from "@fortawesome/pro-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ScreenComponent from "../components/screenComponent";
import {withRouter} from "react-router-dom";

class Contacts extends ScreenComponent {
    constructor(props) {
        super(props);
        this.state = {
            student: {},
            adresses: [],
            contacts: [],
            user: {},
        };
    }

    async componentDidMount() {
        super.componentDidMount();
        await this.getStudent();
        await this.getAdresses();
        await this.getContacts();
        await this.getUser();
    }

    async getContacts() {
        const {body} = await Get(`/v1/extranet/student/${screens.Contacts}02`);

        this.setState({
            contacts: body
        });
    }

    async getAdresses() {
        const {body} = await Get(`/v1/extranet/student/${screens.Contacts}01`);

        this.setState({
            adresses: body
        });
    }

    async getStudent() {
        const {body} = await Get(`/v1/extranet/student/${screens.Contacts}`);

        this.setState({
            student: body
        });
    }

    async getUser() {

        const {body} = await Get(`/v1/extranet/student/${screens.Dashboard}`);

        this.setState({
            user: body
        });
    }

    getAdresseIcon($typeAdresse) {
        switch ($typeAdresse) {
            case "Kot":
                return faLaptopHouse;
            case "Deuxième parent":
                return faHouseUser;
            case "Siège social":
                return faBuilding;
            case "Logement Erasmus":
                return faHotel;
            default:
                return faHome;
        }
    }

    getContactIcon($typeContact) {
        switch ($typeContact) {
            case "Email":
                return faEnvelope;
            case "Téléphone":
                return faPhoneAlt;
            case "GSM":
                return faMobileAlt;
            case "Fax":
                return faFax;
            default:
                return faMailBulk;
        }
    }

    render() {
        return (
            <>
                <Student/>
                <section>
                    <section>
                        <blockquote className="blockquote mb-0">
                            Pour toute demande de modification de vos données, veuillez prendre contact par mail
                            avec votre
                            gestionnaire administratif :
                            <div> {this.state.user.GestionnairesAdministratifs} </div>
                        </blockquote>
                    </section>
                    <Row>
                        <Col className="mb-4" xs={12} lg={4}>
                            <Card className="mb-4" border="primary">
                                <Card.Header className="bg-primary text-white">Informations principales</Card.Header>
                                <Card.Body>
                                    <p>
                                        Né(e)
                                        le {new Date(this.state.student.PersonneDateNaissance).toLocaleDateString()}
                                        &nbsp;à {this.state.student.PersonneLieuNaissance}
                                        {this.state.student.PaysNaissance && " (" + this.state.student.PaysNaissance + ")"}
                                    </p>
                                    <p>
                                        <u>Autre(s)
                                            prénom(s)</u>: {this.state.student.EtudiantPrenom2} {this.state.student.AutresPrenoms}
                                    </p>
                                    <p>
                                        <u>Pays de la nationalité</u>: {this.state.student.PaysNationalite}
                                    </p>
                                    <p>
                                        <u>Etat civil</u>: {this.state.student.EtatCivil}
                                    </p>
                                </Card.Body>
                            </Card>
                            <Card border="primary">
                                <Card.Body>
                                    <Row>
                                        <Col className="p-0 d-flex align-items-center justify-content-end" xs={2}>
                                            <FontAwesomeIcon style={{'fontSize': '3rem'}} icon={faIdCard}/>
                                        </Col>
                                        <Col>
                                            <div>{this.state.student.PersonneNumPieceIdentite}</div>
                                            <div>{this.state.student.PersonneNumRegistreNational}</div>
                                            <div>{new Date(this.state.student.PersonneValiditePieceIdentite).toLocaleDateString()}</div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            {
                                this.state.adresses.map((a, key) => {
                                    return (
                                        <Card key={key} className="mb-4" border="primary">
                                            <Card.Body>
                                                <Row>
                                                    <Col className="p-0 d-flex align-items-center justify-content-end"
                                                         xs={2}>
                                                        <FontAwesomeIcon className="fa-fw"
                                                                         style={{'fontSize': '3rem'}}
                                                                         icon={this.getAdresseIcon(a.TypeAdresse)}/>
                                                    </Col>
                                                    <Col>
                                                        <div>{a.AdresseLigne1}</div>
                                                        <div>{a.AdresseCodePostal} {a.AdresseLocalite}</div>
                                                        <div>{a.Pays}</div>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>

                                    )
                                })
                            }
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            {
                                this.state.contacts.map((a, key) => {
                                    return (
                                        <Card key={key} className="mb-4" border="primary">
                                            <Card.Body>
                                                <Row>
                                                    <Col className="p-0 d-flex align-items-center justify-content-end"
                                                         xs={2}>
                                                        <FontAwesomeIcon className="fa-fw"
                                                                         style={{'fontSize': '3rem'}}
                                                                         icon={this.getContactIcon(a.TypeMoyenContact)}/>
                                                    </Col>
                                                    <Col>
                                                        <div>{a.MoyenContactValeur}</div>
                                                        <div><u>Type</u>: {a.QualificationMoyenContact}</div>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>

                                    )
                                })
                            }
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <Card border="primary">
                                <Card.Body>
                                    <Row>
                                        <Col className="p-0 d-flex align-items-center justify-content-end" xs={2}>
                                            <FontAwesomeIcon style={{'fontSize': '3rem'}} icon={faEuroSign}/>
                                        </Col>
                                        <Col>
                                            <div>{this.state.student.IBANEtudiant}</div>
                                            <div>{this.state.student.BanqueTitulaireCompte}</div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </section>
                <section>
                    <blockquote className="blockquote mb-0">
                        Pour toute demande de modification de vos données, veuillez prendre contact par mail avec votre
                        gestionnaire administratif : <div> {this.state.user.GestionnairesAdministratifs} </div>
                    </blockquote>
                </section>

            </>
        );
    }
}

export default withRouter(Contacts);